import { useDismiss, useFloating, useInteractions } from "@floating-ui/react"
import { useEffect, useState } from "react"
import styles from './styles.module.less'
import { UnitVariable } from "@/components/FlowSheetEditor/components/RightPanel/UnitPanel/components/common/UnitVariable/UnitVariable"
import { Button } from "antd"
import { UnitStates } from "@/components/FlowSheetEditor/components/UnitSelect/UnitSelect"
import { StreamCompositionKey } from "@/components/FlowSheetEditor/components/Header/Simulation/Workbook/VariableTable/attributes"

interface VariablePopoverProps {
  cell: HTMLTableCellElement
  onCancel: () => void
  units: UnitStates
  onChange: (value?: {unitId: string, attrCode: string}) => void
  value: any
}

export const VariablePopover = (props: VariablePopoverProps) => {
  const {cell, onCancel, units, onChange, value: initVal} = props
  const [isOpen, setIsOpen] = useState(true);
  const [value, setValue] = useState<{unitId?: string, attrCode?: string}>({unitId: initVal?.unitId, attrCode: initVal?.attrCode})
  const {refs, floatingStyles, context} = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
  });
  const dismiss = useDismiss(context);
 
  const {getFloatingProps} = useInteractions([
    dismiss
  ]);

  useEffect(() => {
    if (!isOpen) {
      onCancel()
    }
  }, [isOpen, onCancel])

  const rect = cell.getClientRects().item(0)

  useEffect(() => {
    if (cell) {
      refs.setReference(cell)
    }
  }, [cell])

  const handleChange = (val) => {
    setValue(val || {})
  }
  const handleCancel = () => {
    onCancel()
  }

  const handleConfirm = () => {
    const {unitId, attrCode} = value;
    if (unitId && attrCode) {
      onChange(value as any)
      setIsOpen(false)
    }
  }

  if (!rect) return null

  return <div ref={refs.setFloating} style={{width: 300, height: 290, ...floatingStyles}} className={styles.container} {...getFloatingProps()}>
    <h3 className='mb-1'>Link Equipment variable</h3>
      <UnitVariable
        onChange={handleChange}
        value={value}
        units={units || {nodes: [], lines: [], operations: []}} />
      <div className="mt-2 flex-end">
          <Button onClick={handleCancel}>
              Cancel
          </Button>
          <Button
              type="primary"
              onClick={handleConfirm}
              className='ml-1'
              disabled={!(value.unitId && value.attrCode)}
          >
              Save
          </Button>
      </div>
  </div>
}